export class BloodworkNote {
  section?: string; // Ex. RBC, WBC, etc
  text?: string; // actual note text

  constructor(bloodworkNote?: BloodworkNote | any) {
    if (bloodworkNote) {
      this.section = bloodworkNote.section;
      this.text = bloodworkNote.text;
    }
  }
}
